import * as React from "react";
const SvgR5RobotPro20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M0 2h20v13a3 3 0 0 1-5.236 2h-3.528A3 3 0 0 1 6 15V8H2v1.5H0V2Zm18 2v2H2V4h16Zm-4.583 4H18v4.17A3 3 0 0 0 14 15h-2a3 3 0 0 0-4-2.83V8h4.75L10 10.75h3L12.25 13 16 9.25h-3L13.417 8ZM9 14a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm7 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgR5RobotPro20Px;
